export const SECTION_TITLE = 'Loads for You'
export const TOOLTIP_COPY = 'Recommendations are based on past loads and your preferences.'
export const PER_PAGE = 6

export const RECOMMENDED_SHIPMENTS_TEST_IDS = {
  emptyState: 'recommended-shipments-section-empty',
  loadingSkeleton: 'recommended-shipments-section-loading',
  shipmentCard: 'recommended-shipment-card',
}
